export default async function getDiagnosticsByState(dataDefectoStado) {
  // Permite conocer los diagnósticos por estado
  let url = "";

  if (dataDefectoStado.id === "Ninguno") {
    url =
      localStorage.getItem("endpoint") +
      "diagnosticsbystate/" +
      localStorage.getItem("id");
  } else {
    url =
      localStorage.getItem("endpoint") +
      "diagnosticsbystate/" +
      `${localStorage.getItem("id")}?states=${dataDefectoStado.id}`;
  }

  try {
    const config = {
      method: "GET",
      headers: {},
    };
    const response = await fetch(url, config);
    const json = await response.json();
    return json;
  } catch (error) {
    console.log("Error" + error);
    return { payload: {} };
  }
}
